import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import Header from '@/components/Header';
import Litigation from '@/components/Litigation';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const LitigationPage = () => {
  const { setTheme } = useTheme();
  
  useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  return (
    <div className="min-h-screen">
      <Header />
      <SEO
        title="Litigation Services | Freeman & Crown Law"
        description="Strategic litigation support and lawful guidance in federal and state courts. Currently not accepting new litigation cases - check back soon."
        image="/lovable-uploads/bf1e9ff4-07f2-4f37-b82e-54c36221292c.png"
        url={window.location.origin + '/litigation'}
        type="website"
      />
      <Litigation />
      <Footer />
    </div>
  );
};

export default LitigationPage;